var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRightGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.799,
    height: 11.827,
    viewBox: "0 0 6.799 11.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Chevron",
    d: "M8.131-11.352a.8.8,0,0,1-.063.321.909.909,0,0,1-.2.28l-5.2,5.089a.746.746,0,0,1-.548.227.772.772,0,0,1-.4-.1.8.8,0,0,1-.284-.28.741.741,0,0,1-.107-.391.781.781,0,0,1,.247-.568l4.688-4.575L1.579-15.927a.773.773,0,0,1-.247-.561.736.736,0,0,1,.107-.394.806.806,0,0,1,.284-.277.772.772,0,0,1,.4-.1.758.758,0,0,1,.548.22l5.2,5.089a.909.909,0,0,1,.2.28A.8.8,0,0,1,8.131-11.352Z",
    transform: "translate(-1.332 17.263)",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightGray);
export default __webpack_public_path__ + "static/media/icon_arrow_right_gray.a6d2c02cc62ead560f7653a31e20e575.svg";
export { ForwardRef as ReactComponent };